export enum PcsDocumentOrApprovalLocation {
    VESSEL_VISIT = 'VesselVisit',
    VESSEL_NOTIFICATION_ARRIVAL = 'VesselNotificationArrival',
    VESSEL_NOTIFICATION_DEPARTURE = 'VesselNotificationDeparture',
    VESSEL_VISIT_MANOUEVER = 'VesselVisitManouever',
    SERVICE_REQUEST = 'ServiceRequest',
    STORAGE_DOCUMENT = 'StorageDocument',
    AMENDMENT_DOCUMENT = 'AmendmentDocument',
    DELIVERY_ORDER = 'DeliveryOrder',
    GENERAL_ACT = 'GeneralAct'
    // more can be added here later
}
